export default "__VITE_ASSET__DOgtDRzv__"